exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na[data-v-2b91685f] {\n    margin: 0 3px;\n}\n.app-lang[data-v-2b91685f] {\n    padding: 0 3%;\n}\n.active-lang[data-v-2b91685f] {\n    opacity: 0.5;\n}\n.lang-btn[data-v-2b91685f] {\n    min-width: 43px !important;\n    padding: 0 5px !important;\n}\n", ""]);

// exports
